import { AbstractControl, ValidationErrors } from "@angular/forms";

/**
 * enums
 */
import { IFormFieldSizeType } from "../enums/form-field-size";
import { FormFieldUI, IFormFieldUIType } from "../enums/form-field-ui";

export class FromFieldUtils {

    /**
     * @description return class style field size
     * @example 'form-control-sm'
     */
    public static classStyleSize(size: IFormFieldSizeType, type: IFormFieldUIType = FormFieldUI.Control): string {

      // init
      let _prefix: string = '';

      switch(type) {
          case FormFieldUI.Group:
              _prefix = 'input';
              break;
          case FormFieldUI.Control:
          case FormFieldUI.Select:
          default:
              _prefix = 'form'
              break;
          
      }
      

      // value
      return size ? `${_prefix}-${type}-${size}` : '';
        
    }

  /**
   * @description Validate the checkbox value
   */
  public static validate(control: AbstractControl, required: boolean): ValidationErrors | null {

    // if the control is required and the value is false, return an error 
    if (required && (!control.value || control.value?.length === 0)) {
      return { required: true };
    }
    
    // return null if the control is not required or the value is true
    return null;
    
  }
  
}
